import { Component, Output, EventEmitter, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-project-info',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './project-info.html',
  styleUrl: './project-info.scss'
})
export class ProjectInfo {
  s3BaseUrl = environment.s3BaseUrl;
  @Input() isGalleryOpen = false;
  @Output() toggleGallery = new EventEmitter<void>();

  onToggleGallery() {
    this.toggleGallery.emit();
  }

  getImageUrl(path: string): string {
    return `${this.s3BaseUrl}/${path}`;
  }
}
